export default __webpack_public_path__ + "static/media/icon-localisation.cefbabc7.svg";